import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const bookings = [
  { name: "Sarah K.", area: "Downtown", time: "12 min ago" },
  { name: "Jasmine R.", area: "Uptown", time: "27 min ago" },
  { name: "Aaliyah M.", area: "Riverside", time: "41 min ago" },
  { name: "Tiana W.", area: "Midtown", time: "1 hr ago" },
  { name: "Brianna L.", area: "Westside", time: "1 hr ago" },
  { name: "Imani S.", area: "Northside", time: "2 hrs ago" },
  { name: "Destiny J.", area: "Eastside", time: "3 hrs ago" },
  { name: "Nia P.", area: "Lakeside", time: "4 hrs ago" },
];

export const SocialProofTicker = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % bookings.length);
    }, 3500);
    return () => clearInterval(t);
  }, []);

  const b = bookings[idx];

  return (
    <div
      data-testid="social-proof-ticker"
      className="inline-flex items-center gap-3 bg-[#0D0814]/80 backdrop-blur-md border border-[#D4AF37]/25 px-5 py-3 mt-8"
    >
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D4AF37] opacity-60"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#D4AF37]"></span>
      </span>
      <Sparkles className="w-3.5 h-3.5 text-[#D4AF37]" strokeWidth={1.6} />
      <p
        key={idx}
        data-testid="ticker-text"
        className="font-sans text-[12px] sm:text-sm text-[#EAE6DF] tracking-wide"
        style={{ animation: "fadeUp 0.5s ease both" }}
      >
        <span className="text-white font-medium">{b.name}</span>
        <span className="text-[#A89FBB]"> booked a ride · </span>
        <span className="text-[#A89FBB]">{b.area}</span>
        <span className="text-[#A89FBB]"> · </span>
        <span className="gold-text font-medium">{b.time}</span>
      </p>
    </div>
  );
};
